import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  CovidTemplate,
  CovidTemplateCreateRequest,
  CovidTemplateCreateResponse,
  CovidTemplateUpdateRequest,
  CovidTemplateUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {ImportDataService} from '../interface/import-data-service';
import {CovidTemplateByTypeResponse} from '@primatoo-ms-organization';
import {CovidTemplateType, DownloadFormat} from '@pt/pt-models';
import {ApiClientUtils} from '../../api-client.utils';
import { AttachmentType } from 'it/primatoo/openapi/api/org/schemas/common/AttachmentType';

@Injectable({
  providedIn: 'root'
})
export class CovidTemplateService extends ImportDataService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/covid-templates';
  }

  public getCovidTemplates(): Observable<CovidTemplateByTypeResponse> {
    const url = this.endpoint + '/by-type';
    return this.httpClient.get<CovidTemplateByTypeResponse>(url);
  }

  public getCovidTemplateByType(covidTemplateType: CovidTemplateType): Observable<CovidTemplate> {
    const url = this.endpoint + '/by-type?type=' + covidTemplateType;
    return this.httpClient.get<CovidTemplate>(url);
  }

  public deleteCovidTemplate(covidTemplateType: CovidTemplateType): Observable<void> {
    const url = this.endpoint + '/by-type?type=' + covidTemplateType;
    return this.httpClient.delete<void>(url);
  }

  public downloadCovidTemplateExample(covidTemplateType: CovidTemplateType, attachmentExampleName: string, attachmentType: AttachmentType) {
    const url = this.endpoint + '/example/download?type=' + covidTemplateType;
    switch (attachmentType) {
      case AttachmentType.PDF:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.PDF, attachmentExampleName);
        break;
      // case AttachmentType.ZIP:
      //   ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.ZIP);
      //   break;
      case AttachmentType.DOC:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.DOC, attachmentExampleName);
        break;
      case AttachmentType.DOCX:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.DOCX, attachmentExampleName);
        break;
      case AttachmentType.ODT:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.ODT, attachmentExampleName);
        break;
      case AttachmentType.TXT:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.TXT, attachmentExampleName);
        break;
      case AttachmentType.CSV:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.CSV, attachmentExampleName);
        break;
      case AttachmentType.ODS:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.ODS, attachmentExampleName);
        break;
      case AttachmentType.XLS:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.XLS, attachmentExampleName);
        break;
      case AttachmentType.XLSX:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.XLSX, attachmentExampleName);
        break;
      case AttachmentType.PPT:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.PPT, attachmentExampleName);
        break;
      case AttachmentType.PPTX:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.PPTX, attachmentExampleName);
        break;
      case AttachmentType.ODP:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.ODP, attachmentExampleName);
        break;
      case AttachmentType.PNG:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.PNG, attachmentExampleName);
        break;
      case AttachmentType.JPG:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.JPG, attachmentExampleName);
        break;
      case AttachmentType.JPEG:
        ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.JPEG, attachmentExampleName);
        break;
    }
  }

  public createCovidTemplate(requestBody: CovidTemplateCreateRequest): Observable<CovidTemplateCreateResponse> {
    const url = this.endpoint + '/';
    return this.httpClient.post<CovidTemplateCreateResponse>(url, requestBody);
  }

  public updateCovidTemplate(requestBody: CovidTemplateUpdateRequest): Observable<CovidTemplateUpdateResponse> {
    const url = this.endpoint + '/';
    return this.httpClient.put<CovidTemplateUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
